module.exports = __webpack_public_path__ + "img/ultraaa-jakas.073f616c.png";